<template>
    <div>
        <h4 class="title is-4">稿件审核概况</h4>
        <div class="view-rest">
            <el-row :gutter="20">
                <el-col :span="6">
                    <div class="grid-content bg-purple">
                        <strong>今日过审稿件: </strong><span v-text="stat.todayAlready"></span>
                    </div>
                    <div class="grid-content bg-purple">
                        <strong>今日新增待审核稿件: </strong><span v-text="stat.todayAdd"></span>
                    </div>
                    <div class="grid-content bg-purple">
                        <strong>今日我审的稿件: </strong><span v-text="stat.todaySelfAlready"></span>
                    </div>
                    <div class="grid-content bg-purple">
                        <strong>当前剩余未审核稿件: </strong><span v-text="stat.currentRemain"></span>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="grid-content bg-purple">
                        <strong>高热召回队列过审稿件:</strong><span v-text="stat.todayHighAlready"></span>
                    </div>
                    <div class="grid-content bg-purple">
                        <strong>高热召回队列未审稿件:</strong><span v-text="stat.todayHighRemain"></span>
                    </div>
                    <div class="grid-content bg-purple">
                        <strong>投诉召回队列过审稿件: </strong><span v-text="stat.todayComplaintAlready"></span>
                    </div>
                    <div class="grid-content bg-purple">
                        <strong>投诉召回队列未审稿件: </strong><span v-text="stat.todayComplaintRemain"></span>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="grid-content bg-purple">
                        <strong>截屏召回队列过审稿件:</strong><span v-text="stat.todayScreenshotAlready || 0"></span>
                    </div>
                    <div class="grid-content bg-purple">
                        <strong>截屏召回队列未审稿件:</strong><span v-text="stat.todayScreenshotRemain || 0"></span>
                    </div>
                    <div class="grid-content bg-purple">
                        <strong>TOP30召回队列过审稿件: </strong><span v-text="stat.todayTopAlready || 0"></span>
                    </div>
                    <div class="grid-content bg-purple">
                        <strong>TOP30召回队列未审稿件: </strong><span v-text="stat.todayTopRemain || 0"></span>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        type: {
            type: String,
            default: 'article'
        },
        stat: {
            type: Object,
            default () {
                return {
                    currentRemain: 0,
                    todayAdd: 0,
                    todayAlready: 0,
                    todayHighAlready: 0,
                    todayHighRemain: 0,
                    todaySelfAlready: 0,
                    todayComplaintAlready: 0,
                    todayComplaintRemain: 0,
                    todayScreenshotAlready: 0,
                    todayTopAlready: 0,
                    todayScreenshotRemain: 0,
                    todayTopRemain: 0
                };
            }
        }
    },
    computed: {
        isRumor () {
            if (this.type == 'littleVideo' || this.type == 'video') {
                return false;
            }
            return true;
        }
    },
    mounted () {}
};
</script>
